import React, { useEffect, useState } from 'react'

/// React router dom
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
/// Css
import './index.css'
import './chart.css'
import './step.css'

/// Layout
import Nav from './layouts/nav'

///Dashboard
import ViewJob from './components/Dashboard/ViewJob'
import ListJob from './components/Dashboard/ListJob'
import AppliedCandidates from './components/Dashboard/AppliedCandidates'

/// Pages
import Registration from './pages/Registration'
import Login from './pages/Login'
import ForgotPassword from './pages/ForgotPassword'
import PostJob from './components/Dashboard/PostJob'
import ApplyJob from './components/Dashboard/ApplyJob'
import ListCandidate from './components/Dashboard/ListCandidate'
import ViewCandidate from './components/Dashboard/ViewCandidate'
import ViewRecruitingAgents from './components/Dashboard/ListRecruitingAgents'
import EmailOtp from './pages/EmailOtp'
import Error404 from './pages/Error404'
import AgentProfile from './components/Dashboard/AgentProfile'
import EditAgentProfile from './components/Dashboard/EditAgentProfile'
import CreateUsers from './components/Dashboard/CreateUsers'
import ListUsers from './components/Dashboard/ListUsers'
import Dashboard from './components/Dashboard/Dashboard'
import ViewUser from './components/Dashboard/ViewUser'
import ForgotPasswordConfirmation from './pages/ForgetPasswordConfirmation'
import DownloadInvoice from './components/Invoice/DownloadInvoice'
import WorkList from './components/Dashboard/WorkList'
import AgentDashboard from './components/Dashboard/AgentDashboard'
import ListInvoice from './components/Invoice/ListInvoice'
import TopRecruitingAgents from './components/Dashboard/TopRecruitingAgents'
import PrivacyPolicy from './pages/PrivacyPolicy'
import Statistics from './components/Dashboard/Statistics'
import AddMasterData from './components/Dashboard/AddMasterData'
import CompanyMaster from './components/Dashboard/CompanyMaster'

const PageRoutes = () => {
    let path = window.location.pathname;
    path = path.split('/');
    path = path[path.length - 1];
    let pagePath = path.split('-').includes('page');
    const [activeEvent, setActiveEvent] = useState(path);
    const loginRoutes = [
        { url: '', component: Login },
        { url: 'page-register', component: Registration },
        { url: 'page-login', component: Login },
        { url: 'page-forgot-password', component: ForgotPassword },
        { url: 'page-email-otp', component: EmailOtp },
        { url: 'page-notfound', component: Error404 },
        { url: 'page-resetPassword', component: ForgotPasswordConfirmation },
        { url: 'page-privacy-policy', component: PrivacyPolicy },
    ]
    return (
        <div
            id={`${(!pagePath && path) ? 'main-wrapper' : ''}`}
            className={`${(!pagePath && path) ? 'show' : 'mh100vh'}`}
        >
            <div
                className={` ${!path && !pagePath && activeEvent ? 'rightside-event' : ''} ${(!pagePath && path) ? 'content-body' : ''
                    }`}
            >
                <div
                    className={`${(!pagePath && path) ? 'container-fluid' : ''}`}
                    style={{ minHeight: window.screen.height - 60 }}
                >
                    <Switch>
                        {loginRoutes.map((login, i) => (
                            <Route
                                key={i}
                                exact
                                path={`/${login.url}`}
                                component={login.component} />
                        ))}
                    </Switch>
                </div>
            </div>
        </div>
    )
}

const ComponentRoutes = () => {
    const loggedInUser = JSON.parse(localStorage.getItem('user'))
    let path = window.location.pathname;
    path = path.split('/');
    path = path[path.length - 1];
    let pagePath = path.split('-').includes('page');
    const [activeEvent, setActiveEvent] = useState(path);

    const adminRoutes = [
        { url: 'add-job', component: PostJob },
        { url: 'view-job', component: ViewJob },
        { url: 'list-job', component: ListJob },
        { url: 'apply-job', component: ApplyJob },
        { url: 'list-candidate', component: ListCandidate },
        { url: 'view-candidate', component: ViewCandidate },
        { url: 'applied-candidates', component: AppliedCandidates },
        { url: 'list-recruiting-agent', component: ViewRecruitingAgents },
        { url: 'company-master', component: CompanyMaster },
        { url: 'agent-profile', component: AgentProfile },
        { url: 'edit-agent-profile', component: EditAgentProfile },
        { url: 'create-user', component: CreateUsers },
        { url: 'list-user', component: ListUsers },
        { url: 'dashboard', component: Dashboard },
        { url: 'master-data', component: AddMasterData },
        { url: 'statistics', component: Statistics },
        { url: 'view-user', component: ViewUser },
        { url: 'download-invoice', component: DownloadInvoice },
        { url: 'list-invoice', component: ListInvoice },
        { url: 'top-recruiting-agents', component: TopRecruitingAgents },
    ]
    const agentRoutes = [
        { url: 'view-job', component: ViewJob },
        { url: 'list-job', component: ListJob },
        { url: 'apply-job', component: ApplyJob },
        { url: 'list-candidate', component: ListCandidate },
        { url: 'view-candidate', component: ViewCandidate },
        { url: 'applied-candidates', component: AppliedCandidates },
        { url: 'agent-profile', component: AgentProfile },
        { url: 'edit-agent-profile', component: EditAgentProfile },
        { url: 'download-invoice', component: DownloadInvoice },
        { url: 'agent-dashboard', component: AgentDashboard },
        { url: 'work-list', component: WorkList },
        { url: 'top-recruiting-agents', component: TopRecruitingAgents },
    ]
    const internalRoutes = [
        { url: 'add-job', component: PostJob },
        { url: 'view-job', component: ViewJob },
        { url: 'list-job', component: ListJob },
        { url: 'apply-job', component: ApplyJob },
        { url: 'list-candidate', component: ListCandidate },
        { url: 'view-candidate', component: ViewCandidate },
        { url: 'applied-candidates', component: AppliedCandidates },
        { url: 'list-recruiting-agent', component: ViewRecruitingAgents },
        { url: 'list-user', component: ListUsers },
        { url: 'agent-profile', component: AgentProfile },
        { url: 'view-user', component: ViewUser },
        { url: 'edit-agent-profile', component: EditAgentProfile },
        { url: 'dashboard', component: Dashboard },
        { url: 'download-invoice', component: DownloadInvoice },
        { url: 'top-recruiting-agents', component: TopRecruitingAgents },
        { url: 'master-data', component: AddMasterData },
    ]
    const accountRoutes = [
        { url: 'list-invoice', component: ListInvoice },
        { url: 'download-invoice', component: DownloadInvoice },
        { url: 'view-candidate', component: ViewCandidate },
    ]
    const keyAccountManagerRoutes = [
        { url: 'add-job', component: PostJob },
        { url: 'view-job', component: ViewJob },
        { url: 'list-job', component: ListJob },
        { url: 'apply-job', component: ApplyJob },
        { url: 'list-candidate', component: ListCandidate },
        { url: 'view-candidate', component: ViewCandidate },
        { url: 'applied-candidates', component: AppliedCandidates },
        { url: 'list-recruiting-agent', component: ViewRecruitingAgents },
        { url: 'company-master', component: CompanyMaster },
        { url: 'agent-profile', component: AgentProfile },
        { url: 'edit-agent-profile', component: EditAgentProfile },
        { url: 'dashboard', component: Dashboard },
        { url: 'master-data', component: AddMasterData },
        { url: 'statistics', component: Statistics },
        { url: 'view-user', component: ViewUser },
        { url: 'download-invoice', component: DownloadInvoice },
        { url: 'list-invoice', component: ListInvoice },
        { url: 'top-recruiting-agents', component: TopRecruitingAgents },
    ]

    const routes = loggedInUser?.roles === 'Admin' ? adminRoutes
        : loggedInUser?.roles === 'Internal Recruiter' ? internalRoutes
            : loggedInUser?.roles === 'Accountant' ? accountRoutes 
                : loggedInUser?.roles === 'Key Account Manager' ? keyAccountManagerRoutes : agentRoutes

    var notFound = routes?.filter((route) => route?.url === path)
   if (notFound.length === 0) {
        return <Redirect to='/page-notFound' />
    }
    else {
        return (
            <div
                id={`${(!pagePath && path) ? 'main-wrapper' : ''}`}
                className={`${(!pagePath && path) ? 'show' : 'mh100vh'}`}
            >
                <Nav
                    onClick={() => setActiveEvent(!activeEvent)}
                    activeEvent={activeEvent}
                    onClick2={() => setActiveEvent(false)}
                    onClick3={() => setActiveEvent(true)}
                />
                <div
                    className={` ${!path && !pagePath && activeEvent ? 'rightside-event' : ''} ${(!pagePath && path) ? 'content-body' : ''
                        }`}
                >
                    <div
                        className={`${(!pagePath && path) ? 'container-fluid' : ''}`}
                        style={{ minHeight: window.screen.height - 60 }}
                    >
                        <Switch>
                            {routes.map((data, i) => (
                                <ProtectedRoutes
                                    key={i}
                                    exact
                                    path={`/${data.url}`}
                                    component={data.component}
                                />
                            ))}
                        </Switch>
                    </div>
                </div>
            </div>
        )
    }
}
const Markup = () => {
    useEffect(() => {
        const currentHost = window.location.hostname;
        const currentPath = window.location.pathname;
        const targetDomain = "adhaan.flickjobs.in";
    
        if (currentHost === "flickjobs.in") {
          window.location.href = `https://${targetDomain}${currentPath}`;
        }
      }, []);
    return (
        <Router basename='/adhaan/marketplace'>
            <Switch>
                <Route exact path={["/",
                    "/page-login",
                    "/page-register",
                    "/page-forgot-password",
                    "/page-email-otp",
                    "/page-notfound",
                    "/page-resetPassword",
                    "/page-privacy-policy"]} component={PageRoutes} />
                <ProtectedRoutes component={ComponentRoutes} />
            </Switch>
        </Router>
    )
}

export default Markup;

export function ProtectedRoutes(props) {
    let path = window.location.pathname.includes("page") ? true : false
    const loggedInUser = JSON.parse(localStorage.getItem('user'))

    if (!path && !loggedInUser) {
        return <Redirect to='/page-login' />
    }
    else {
        return <Route {...props} />
    }
}

